import { CashOnCashExport } from 'src/app/domain/cashflow/dto/CashOnCashExport';
import { CashOnCashHeaders } from './interfaces';
import { CashFlowMiniDTO } from 'src/app/domain/cashflow/dto/CashFlowMiniDTO';

/**
 * Get table headers for viewer or admin.
 *
 * @returns array of table headers.
 */
export const getHeaders = (cashFlowList: CashFlowMiniDTO[], exportExcelData: CashOnCashExport): CashOnCashHeaders => {
  const dates = [];
  cashFlowList.forEach((cashflow) => {
    dates.push(cashflow.transactionDate.toString());
  });
  const headersDisplayed = ['', ...dates];
  const headersForLogic = ['', ...dates];
  if (exportExcelData.withDue) {
    headersDisplayed.push(exportExcelData.selectedPeriod);
    headersForLogic.push('Due to company');
  }
  if (exportExcelData.withReceivables) {
    headersDisplayed.push(exportExcelData.selectedPeriod);
    headersForLogic.push('Receivables');
  }
  headersDisplayed.push(exportExcelData.selectedPeriod, 'Gain/Loss', 'IRR', 'MOIC');
  headersForLogic.push('Unrealized value', 'Gain/Loss', 'IRR', 'MOIC');
  return { headersDisplayed, headersForLogic, dates };
};

export const getHeadersForCashOnCash = (cashFlowList: CashFlowMiniDTO[]): string[] => {
  const dates: string[] = [];
  cashFlowList.forEach((cashflow) => {
    dates.push(cashflow.transactionDate.toString());
  });
  return dates;
};

